<template>
  <span></span>
</template>
<script>
import { manager, initAuth } from '@/auth'

export default {
  name: 'AuthCallbackSilent',
  async mounted () {
    if (manager != null) {
      manager.signinSilentCallback()
    } else {
      await initAuth()
    }
  }
}
</script>
<style></style>
